export default __webpack_public_path__ + "static/media/conversion_rate.42aec5ee.svg";